import PropTypes from 'prop-types';

import { isDesktopEnvironment } from 'utils/helper';

const DesktopOnly = ({ children }) => {
  if (!isDesktopEnvironment()) return null;
  return children;
};

DesktopOnly.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DesktopOnly;
